export default __webpack_public_path__ + "static/media/HomemK.4868d254.png";